import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Quote, ArrowRight } from 'lucide-react';
import { Impact } from '../components/Impact';
import { testimonies } from '../data/testimonies';
export function ImpactPage() {
  return <main className="flex-grow pt-24" data-id="element-470" data-mp="25o5xp0dqjxcb">
      <div className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-471" data-mp="2aobjhzxbqpmh">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-472" data-mp="1woslw1252wof" />

        <div className="relative z-10" data-id="element-473" data-mp="21pq6ekamg2t3">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-474" data-mp="1mreawgyzj03i">
            The Evidence
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6" data-id="element-475" data-mp="1kvj1a0tml9yd">
            Our{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-476" data-mp="1pmiyl76npu1e">
              Impact
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto px-6" data-id="element-477" data-mp="11xq6xmx2i8cl">
            Witness the lives touched and transformed through the power of
            prayer and outreach.
          </motion.p>
        </div>
      </div>

      <Impact data-id="element-478" data-mp="2idj4jnojt7vp" />

      <section className="py-32 bg-ivory text-midnight" data-id="element-479" data-mp="1f0j3n5lhvevr">
        <div className="max-w-7xl mx-auto px-6" data-id="element-480" data-mp="1f00y1icxzob6">
          <div className="text-center mb-16" data-id="element-481" data-mp="1jzdk40vzorcp">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-482" data-mp="1jycbe32g4gy5">
              Testimonies
            </div>
            <h3 className="text-5xl md:text-7xl font-display font-bold tracking-tighter" data-id="element-483" data-mp="1sz0n2r4da57v">
              Stories of{' '}
              <span className="font-serif italic font-medium text-gold" data-id="element-484" data-mp="wbw04riyuxka">
                Transformation
              </span>
            </h3>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-485" data-mp="15ahe09dhtoeq">
            {testimonies.map((testimony, idx) => <motion.div key={testimony.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} data-id="element-486" data-mp="1a2964ocas26z" data-mpi={idx}>
                <Link to={`/testimonies/${testimony.slug}`} className="group bg-white p-8 rounded-[2rem] border-2 border-midnight/5 shadow-sm relative block h-full flex flex-col hover:shadow-xl hover:-translate-y-2 transition-all duration-300" data-id="element-487" data-mp="10xs7071pe5u">
                  <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-gold group-hover:text-midnight transition-colors text-gold" data-id="element-488" data-mp="3ihfn4auoms0b">
                    <Quote className="w-5 h-5" data-id="element-489" data-mp="3dg9v6f8uj8ru" />
                  </div>

                  <h4 className="text-2xl font-display font-bold text-midnight mb-4 group-hover:text-gold transition-colors leading-tight" data-id="element-490" data-mp="39ic416vimclt">
                    {testimony.title}
                  </h4>
                  <p className="text-base text-charcoal/70 font-medium leading-relaxed mb-8 flex-grow" data-id="element-491" data-mp="2zj3ecq7onk59">
                    {testimony.excerpt}
                  </p>

                  <div className="pt-6 border-t-2 border-midnight/5 flex items-center justify-between" data-id="element-492" data-mp="18et3s6yzcicp">
                    <p className="font-bold text-midnight text-sm uppercase tracking-wider" data-id="element-493" data-mp="tqf23zdauzxq">
                      {testimony.name}
                    </p>
                    <div className="w-10 h-10 rounded-full bg-midnight/5 flex items-center justify-center group-hover:bg-midnight group-hover:text-ivory transition-colors" data-id="element-494" data-mp="ymdmzczf5zte">
                      <ArrowRight className="w-4 h-4" data-id="element-495" data-mp="os3pxhzj8dcc" />
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </div>
      </section>
    </main>;
}